import { Dispatch } from 'react';

interface RowData {
  Id: string | number | undefined;
  [key: string]: unknown;
}

export const useCustomAddCopy = (
  currentRowData: RowData,
  setCurrentRowData: Dispatch<RowData>,
  setShowPopup: Dispatch<boolean>
) => {
  const handleAdd = () => {
    setCurrentRowData({ Id: currentRowData.Id, mode: 'add' });
    setShowPopup(true);
  };

  const handleCopy = () => {
    if (!currentRowData.Id) return;

    setCurrentRowData({ ...currentRowData, mode: 'copy' });
    setShowPopup(true);
  };

  return [handleAdd, handleCopy];
};
